import { apiClient } from '@/app/network/apiClient';
import { remoteAppConfigFromJson, type RemoteAppConfig } from '../domain/remoteAppConfig';

export async function fetchRemoteConfig(): Promise<RemoteAppConfig> {
  const body = await apiClient.get<Record<string, unknown>>('/v1/config', { anonymous: true });
  return remoteAppConfigFromJson(body);
}
